"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVerificationTemplate = void 0;
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const typedi_1 = require("typedi");
const translation_1 = require("@translation/services/translation");
const user_1 = require("@auth/services/user");
const control_1 = require("@common/form/control");
const ticker_1 = require("@common/utils/ticker");
const loader_1 = require("@common/loader/templates/loader");
const popup_1 = require("../services/popup");
/**
 * Всплывающее окно верификации пользователя
 */
let VerificationPopup = class VerificationPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = true;
        /**
         * Процесс подтверждения
         */
        this.verification = false;
        /**
         * Процесс запроса на подтверждение
         */
        this.requesting = false;
        /**
         * Подтвержденный пользователь
         */
        this.confirmed = false;
        /**
         * Отображение таймера
         */
        this.timerShown = false;
        /**
         * Ошибка
         */
        this.error = '';
        /**
         * Форма
         */
        this.form = new control_1.Form({
            code: new control_1.TextControl(''),
        });
        /**
         * Последнее время отправки
         */
        this.lastTimeSent = 0;
        /**
         * Маска отображения отсчета таймера
         */
        this.timerMask = '';
        /**
         * Сообщение отсчета
         */
        this.timerMessage = '';
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.userService = typedi_1.Container.get(user_1.UserService);
        this.popupService = typedi_1.Container.get(popup_1.PopupService);
        this.verify = this.verify.bind(this);
        this.back = this.back.bind(this);
        this.tick = this.tick.bind(this);
        this.requestToVerify = this.requestToVerify.bind(this);
        this.ticker = new ticker_1.Ticker(this.tick);
        this.timerMask = this.translationService.instant('ec.resend_message');
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Обрабатывает событие инициализации
     */
    connectedCallback() {
        super.connectedCallback();
        setTimeout(() => this.init(), 1000);
    }
    /**
     * Генерирует представление
     */
    render() {
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <div class="modal-header pb-4">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        ${this.error
            ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                ${this.error}
                            </div>
                        ` : this.loading ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    ${(0, loader_1.getLoaderTemplate)(true, this.translationService)}
                                </div>
                            </div>
                        ` : !this.confirmed
            ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <h2>${this.translationService.instant('ec.verify_email')}</h2>
                                <p class="mb-5">${this.translationService.instant('ec.verify_text_1')}</p>
                                <art-text-field class="d-block mb-3" name="code" placeholder="${this.translationService.instant('code')}" .control="${this.form.get('code')}" @enter="${this.verify}"></art-text-field>
                                <button class="btn btn-secondary" @click="${this.verify}">${this.translationService.instant('verify')}</button>
                                <div class="mt-5">
                                    ${!this.timerShown ? (0, lit_html_1.html) `
                                        <a class="link__more" href="#" style="margin: 0;" @click="${this.requestToVerify}">${this.translationService.instant('ec.resend_action')}</a>
                                    ` : ''}
                                    ${this.timerShown ? (0, lit_html_1.html) `
                                        <div>${this.timerMessage}</div>
                                    ` : ''}
                                </div>
                                <hr />
                                <div>
                                    ${this.translationService.instant('ec.help_message_0')}<br />
                                    ${this.translationService.instant('ec.help_message_1_0')}
                                    <a class="link" href="/cp/clientarea.php?action=details">${this.translationService.instant('ec.help_message_1_1')}</a>
                                    ${this.translationService.instant('ec.help_message_1_2')}
                                </div>
                            </div>
                        ` : (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <h2>${this.translationService.instant('ec.congratulations')}</h2>
                                <p class="mb-5">${this.translationService.instant('ec.success')}</p>
                               
                                <button class="btn btn-secondary" @click="${this.back}">${this.translationService.instant('back')}</button>
                            </div>
                        `}
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Инициализирует состояние
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            try {
                const { data } = yield this.userService.info();
                if (data.guest) {
                    this.popupService.open('login', {});
                    return;
                }
                this.confirmed = data.confirmed;
                if (!this.confirmed) {
                    yield this.requestToVerify();
                }
            }
            catch (err) {
                this.error = err.message;
            }
            finally {
                this.loading = false;
            }
        });
    }
    /**
     * Запрашивает подтверждение
     */
    requestToVerify() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.requesting) {
                return;
            }
            this.requesting = true;
            try {
                yield this.userService.requestToVerify();
                this.lastTimeSent = Date.now();
                this.ticker.start();
            }
            catch (err) { }
            finally {
                this.requesting = false;
            }
        });
    }
    /**
     * Подтверждает пользователя
     */
    verify() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.verification = true;
            try {
                yield this.userService.verify((_a = this.form.get('code')) === null || _a === void 0 ? void 0 : _a.getValue());
                this.confirmed = true;
            }
            catch (err) {
                if (err.errors) {
                    this.form.setErrors(err.errors);
                }
            }
            finally {
                this.verification = false;
            }
        });
    }
    /**
     * Перемещает пользователя назад
     */
    back() {
        this.popupService.close();
    }
    /**
     * Обрабатывает тик счетчика
     */
    tick() {
        var time = Date.now() - this.lastTimeSent;
        time = Math.floor(time / 1000);
        if (time >= 60) {
            this.ticker.stop();
            this.lastTimeSent = 0;
            this.timerShown = false;
            return;
        }
        let rest = 60 - time;
        // @ts-ignore
        rest = ('0' + rest).slice(-2);
        this.timerMessage = this.timerMask.replace(':time', '00:' + rest);
        this.timerShown = true;
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], VerificationPopup.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], VerificationPopup.prototype, "verification", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], VerificationPopup.prototype, "requesting", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], VerificationPopup.prototype, "confirmed", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], VerificationPopup.prototype, "timerShown", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", String)
], VerificationPopup.prototype, "error", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Object)
], VerificationPopup.prototype, "timerMessage", void 0);
VerificationPopup = __decorate([
    (0, decorators_js_1.customElement)('art-verification-popup'),
    __metadata("design:paramtypes", [])
], VerificationPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getVerificationTemplate() {
    return (0, lit_html_1.html) `<art-verification-popup></art-verification-popup>`;
}
exports.getVerificationTemplate = getVerificationTemplate;
window.PopupController.registerTemplate('verification', getVerificationTemplate);
